<template>
  <div>
    <div class="topbar">
      <NavigationBar ref='NavigationBar' />
    </div>
    <div class="leftMenu">
      <Menu @changeMenuStatus="changeMenuStatus" :menuStatus='menuStatus'></Menu>
    </div>
    <div :class="mainInfo">
      <div class="tagActive">
        <tags-view />
      </div>
      <RoutingExport />
    </div>
    <!-- <Notify @MessageBoxUnread='MessageBoxUnread' :NotifyList="NotifyList" /> -->
  </div>
</template>
<script>
import NavigationBar from './NavigationBar/index'
import RoutingExport from './RoutingExport/index'
import Menu from './menu/index'
import TagsView from './TagsView/index'
import { mapGetters, mapState } from 'vuex'
// import Notify from '@/components/Notify'
export default {
  components: {
    NavigationBar, RoutingExport, Menu, TagsView
  },
  computed: {
    ...mapGetters(['menuStatus', 'user']),
    ...mapState(['websockIp'])
  },
  watch: {
    menuStatus (newval) {
      this.changeMenuStatus(newval)
    }
  },
  data () {
    return {
      NotifyList: [
        // {
        //   aimCompanyType: 1,
        //   createTime: 1626661244,
        //   msgRemark: '订单等待退票审核',
        //   msgStatus: 1,
        //   orderId: '21071513643399230632',
        //   orderIdType: 3,
        //   orderMessageBoxId: '448806567790661632',
        //   orderStatus: 310,
        //   statusRemark: '订单等待退票审核'
        // }
      ],
      homepageNumtesShow: true,
      mainInfo: 'mainInfoSmall',
      details: [],
      // websockIp: '47.102.141.247:9371',
      lockReconnect: false,
      websock: null,
      i: 0,
      heartBeatTime: 30000,
      relinktimes: 10
    }
  },
  methods: {
    MessageBoxUnread () {
      this.$refs['NavigationBar'].MessageBoxUnread()
    },
    // 主体大小变化
    changeMenuStatus (val) {
      this.mainInfo = val === true ? 'mainInfoSmall' : 'mainInfoBig'
    },
    // notesShow () {
    //   MessageListShow({}).then((res) => {
    //     if (res.data.code === 200) {
    //       this.details = res.data.data
    //     }
    //   })
    // },
    // closeMessage () {
    //   this.$notify.close()
    // },
    reConnect () {
      clearTimeout(this.timeoutObj)
      clearTimeout(this.timeoutObjstop)
      this.initWebSocket()
    },
    ping () {
      clearTimeout(this.timeoutObj)
      clearTimeout(this.timeoutObjstop)
      this.start()
    },
    start () {
      this.timeoutObj = setTimeout(() => {
        // console.log('发送心跳消息ping')
        // this.websocketsend('PING_' + this.user.user.id)
        this.websocketsend('PING')
      }, this.heartBeatTime)
      this.timeoutObjstop = setTimeout(() => {
        this.initWebSocket()
      }, this.heartBeatTime * 10)
    },
    // 初始化连接
    initWebSocket () {
      clearTimeout(this.timeoutObj)
      clearTimeout(this.timeoutObjstop)
      // const token = this.$store.state.user.token
      // const userCode = this.$store.state.user.user.userCode
      // const wsuri = 'ws://' + this.websockIp + '/websocket?token=' + token
      // const params = {
      //   userCode: userCode,
      //   token: token
      // }
      const wsuri = 'ws://' + this.websockIp + '/webSocket/' + this.user.userId
      this.websock = new WebSocket(wsuri)
      this.websock.onmessage = this.websocketonmessage
      this.websock.onclose = this.websocketclose
      this.websock.onopen = this.websocketopen
    },
    // 开启连接
    websocketopen () {
      this.start()
      console.log('websocket连接成功')
    },
    // 发送消息
    websocketsend (msg) {
      this.websock.send(msg)
    },
    // 关闭连接
    websocketclose (e) {
      this.websock.close()
      clearTimeout(this.timeoutObj)
      clearTimeout(this.timeoutObjstop)
      console.log('websocket连接关闭')
      if (this.i < this.relinktimes) {
        if (this.lockReconnect) return
        this.lockReconnect = true
        setTimeout(() => {
          this.i++
          console.log('第' + this.i + '次连接')
          this.initWebSocket()
          this.lockReconnect = false
        }, this.heartBeatTime)
      }
    },
    // 关闭连接不重启
    close () {
      this.i = 100
      clearTimeout(this.timeoutObj)
      clearTimeout(this.timeoutObjstop)
      this.websock.close()
    },
    // 数据接收
    websocketonmessage (event) {
      // console.log(event.currentTarget.readyState)
      if (event.currentTarget.readyState === 3) {
        console.log('接收readyState为3到回应，开启重连')
        this.reConnect()
        return
      }
      if (event.data === '接收到：PING') {
        // console.log('接收到回应，开启下一次心跳')
        this.ping()
        return
      }
      // console.log('接收到数据消息，开启下一次心跳')
      this.NotifyList.push(JSON.parse(event.data).data)
      this.MessageBoxUnread()
      this.ping()
    }
  },
  created () {
    // this.initWebSocket()
    // this.notesShow()
  },
  // 页面关闭断开连接
  destroyed () {
    // this.close()
  }
}
</script>
<style lang='scss'>
.topbar {
  height: 45px;
}
.leftMenu {
}
.tagActive {
  position: fixed;
  z-index: 11;
  top: 45px;
  width: 100%;
  padding: 0px;
}
.mainInfoSmall {
  margin-left: 165px;
}
.mainInfoBig {
  margin-left: 0px;
}
.myMessageStyle {
  width: 333px !important;
  display: flex;
  .el-notification__icon {
    color: #3398cc;
  }
  .el-notification__title {
    font-weight: 600;
    font-size: 15px;
    color: #e57142;
    margin: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Layout/index.vue